import { Injectable } from '@angular/core';
import {
  HttpHeaders,
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { User } from '../_models';
import { environment } from '@environments/environment';
import { AppConfig } from 'src/assets/config/config/app-config';

const httpOptions = {
  headers: new HttpHeaders({
    Authorization: 'Basic d2JhZG1pbjp3YmFkbWlu',
  }),
};
//const workflowJBPMServerUrl = `${environment.workflowJBPMServerUrl}`

//const containerId="business-application-kjar-1_0-SNAPSHOT"
//const containerId = "Demo_1.0.0-SNAPSHOT"
// const containerId = "business-application-kjar-1_0-SNAPSHOT"

// //const processId="business-application-kjar.Doc_Review"
// const processId = "GenericWorkflow_v1._2StepWorkflow"

@Injectable({
  providedIn: 'root',
})
export class WorkflowService {
  currentUser: User;
  workflowUrl: string;
  processId: string;
  containerId: string;
  updateWorkflowUrl: string;
  enableWorkflow: boolean = this.config.getConfig('enableWorkflow');
  apiUrl: String;
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private config: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.apiUrl = this.config.getConfig('apiUrl');
    if (this.enableWorkflow) {
      // this.getWorkflowDetails().subscribe(details => {
      // this.workflowUrl = details.jbpmbaseurl
      // this.processId = details.processid
      // this.containerId = details.container
      // this.updateWorkflowUrl = details.queueupdateurl
      // })
      this.workflowUrl = config.getConfig('workflowJBPMServerUrl');
      this.processId = config.getConfig('workflowJBPMProcessId');
      this.containerId = config.getConfig('workflowJBPMContainerId');
      this.updateWorkflowUrl = this.workflowUrl+`/containers/`+this.containerId+`/processes/`+this.processId+`/instances`;
    }
  }

  getUserTaskList() {
    console.log('username', this.currentUser.username);
    return this.http.get<any>(
      this.apiUrl + `/workflow/get-user-tasks/` + this.currentUser.username
    );
  }

  getQueueTaskList(queue) {
    return this.http.get<any>(
      this.apiUrl + `/workflow/get-queue-tasks/` + queue
    );
  }

  getWorkflowDetails() {
    return this.http
      .get<any>(this.apiUrl + `/workflow/get-wfdetails`)
      .pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    return throwError(error);
  }
  //****** Lastes Code ******//
  // getQueueDetails(queueId) {
  //     if (queueId) {
  //         var payload = {
  //             queue_id: queueId
  //         }
  //     }
  //     return this.http.post<any>(`${environment.apiUrl}/workflow/retrieve-queue`, payload)
  //         .pipe(catchError(this.errorHandler))
  // }

  getProcessesForUser() {
    return this.http
      .get<any>(
        this.workflowUrl +
          `/queries/processes/instances/variables/Owner?varValue=${this.currentUser.username}&pageSize=1000`, httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  getProcessesForDocument(documentId) {
    return this.http
      .get<any>(
        this.workflowUrl +
          `/queries/processes/instances/variables/DocID?varValue=${documentId}&pageSize=1000`,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  getProcessesForQueue(queue) {
    return this.http
      .get<any>(
        this.workflowUrl +
          `/queries/processes/instances/variables/Queue?varValue=${queue}&pageSize=1000`,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  initiateWorkflow(documentId, queue) {
    var payload = {
      DocID: documentId,
      Queue: queue,
      Owner: this.currentUser.username,
    };
    return this.http
      .post<any>(
        this.workflowUrl +
          `/containers/${this.containerId}/processes/vault-workflows-kjar._1StepDynamicProcess/instances`,
        payload,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  assignTaskToQueue(queue, processId) {
    var payload = {
      Queue: queue,
      Owner: '',
    };
    return this.http
      .post<any>(
        this.workflowUrl +
          `/containers/${this.containerId}/processes/instances/${processId}/variables`,
        payload,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  claimTask(processId) {
    var payload = {
      Owner: this.currentUser.username,
    };
    return this.http
      .post<any>(
        this.workflowUrl +
          `/containers/${this.containerId}/processes/instances/${processId}/variables`,
        payload,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  // getProcessDetails(processId) {
  //     return this.http.get<JSON>(this.workflowUrl+`/containers/vault-workflows-kjar-1_0-SNAPSHOT/processes/instances/${processId}/variables/instances`)
  //         .pipe(catchError(this.errorHandler))
  // }

  getAllTasks(processIds) {
    var queryParams = {
      'query-params': [
        {
          'cond-column': 'variableid',
          'cond-operator': 'IN',
          'cond-values': ['Queue', 'DocID', 'Owner'],
        },
        {
          'cond-column': 'processInstanceId',
          'cond-operator': 'IN',
          'cond-values': processIds,
        },
      ],
    };
    return this.http
      .post<JSON>(
        this.workflowUrl +
          `/queries/definitions/jbpmProcessInstancesWithVariables/filtered-data?mapper=ProcessInstancesWithVariables&pageSize=1000`,
        queryParams,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  getProcessDetails(processId) {
    var queryParams = {
      'query-params': [
        {
          'cond-column': 'variableid',
          'cond-operator': 'IN',
          'cond-values': ['Queue', 'DocID', 'Owner'],
        },
        {
          'cond-column': 'processInstanceId',
          'cond-operator': 'IN',
          'cond-values': processId,
        },
      ],
    };
    return this.http
      .post<JSON>(
        this.workflowUrl +
          `/queries/definitions/jbpmProcessInstancesWithVariables/filtered-data?mapper=ProcessInstancesWithVariables&pageSize=1000`,
        queryParams,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  closeTask(queue, status, processId) {
    var payload = {
      Queue: '',
      Status: status,
      Owner: '',
    };
    return this.http
      .post<JSON>(
        this.workflowUrl +
          `/containers/${this.containerId}/processes/instances/${processId}/variables`,
        payload,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  getQueueHistoryForProcess(processId) {
    return this.http
      .get<JSON>(
        this.workflowUrl +
          `/containers/${this.containerId}/processes/instances/${processId}/variables/instances/Queue`,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  getOwnerHistoryForProcess(processId) {
    return this.http
      .get<JSON>(
        this.workflowUrl +
          `/containers/${this.containerId}/processes/instances/${processId}/variables/instances/Owner`,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }

  returnToQueue(processId) {
    var payload = {
      Owner: '',
    };
    return this.http
      .post<any>(
        this.workflowUrl +
          `/containers/${this.containerId}/processes/instances/${processId}/variables`,
        payload,httpOptions
      )
      .pipe(catchError(this.errorHandler));
  }
}
